import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
	selector: "app-change-partition-dialog",
	templateUrl: "./change-partition-dialog.component.html",
	styleUrl: "./change-partition-dialog.component.scss",
	standalone: false
})
export class ChangePartitionDialogComponent {
	constructor(public dialogRef: MatDialogRef<ChangePartitionDialogComponent>) { }

	close() {
		this.dialogRef.close();
	}

	ok() {
		this.dialogRef.close("ok");
	}
}